import React, { useState } from 'react';
import TriStateToggle from './TriStateToggle';
import './CategoryFilter.css'


const CategoryFilter = ({ onFilter, parentCategories }) => {
  const [parentType, setParentType] = useState("all");
  const [description, setDescription] = useState('');
  const [selectedId, setSelectedId] = useState();

  const handleParentTypeChange = (newType) => {
    setParentType(newType);

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter({
      parentType, selectedId, description
    });
  };
  return (
    <form onSubmit={handleSubmit} className="row g-3">
      <div className="col-md-4">
        <label htmlFor="name" className="form-label">
          Kategória Neve:
        </label>
        <select
          id="category"
          className="form-select"
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          <option value="">Válassz kategóriát</option>
          {parentCategories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-4">
        <label htmlFor="category" className="form-label">
          Szülő Kategória:
        </label>
        <TriStateToggle
          value={parentType}
          onChange={handleParentTypeChange}
        />
      </div>

      <div className="col-md-4">
        <label htmlFor="description" className="form-label">
          Leírás:
        </label>
        <input
          type="text"
          id="description"
          className="form-control"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Keresés leírás szerint"
        />

      </div>
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary">
          Szűrés
        </button>
      </div>
    </form>
  );

}

export default CategoryFilter;
